// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Link,
// } from "@mui/material";
// import axios from "axios";
// import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";

// const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

// // Walks the axios error shape to return the most useful message string
// const extractErrorMessage = (
//   error,
//   fallback = "Something went wrong. Please try again.",
// ) => {
//   if (error?.response?.data?.data?.message)
//     return error.response.data.data.message;
//   if (error?.response?.data?.message) return error.response.data.message;
//   if (error?.message === "Network Error")
//     return "Network error. Please check your connection.";
//   if (error?.message) return error.message;
//   return fallback;
// };

// const FilterLoginScreen = ({
//   onLoginSuccess,
//   linkName,
//   linkId,
//   store_id,
//   mfr_id,
//   linkPrivacy,
//   storeInformation,
//   contactDM,
// }) => {
//   // ✅ UNIFIED STORAGE KEY
//   const UNIFIED_STORAGE_KEY = "FILTER_LINK_LOGIN_UNIFIED";

//   const [mobile, setMobile] = useState("");
//   const [showOTPSection, setShowOTPSection] = useState(false);
//   const [showNameSection, setShowNameSection] = useState(false);
//   const [name, setName] = useState("");
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [userInfo, setUserInfo] = useState(null);
//   const [requestSent, setRequestSent] = useState(false);
//   const [showNonExistingUserError, setShowNonExistingUserError] =
//     useState(false);
//   const [isCheckingAccess, setIsCheckingAccess] = useState(true);
//   const [isRequesting, setIsRequesting] = useState(false);

//   // Retry feature states
//   const [isRetrying, setIsRetrying] = useState(false);
//   const [lastRetryTime, setLastRetryTime] = useState(null);
//   const [retryMessage, setRetryMessage] = useState("");

//   // Snackbar
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//   // ONLY access check for private links
//   useEffect(() => {
//     const checkAccessAndAutoLogin = async () => {
//       // Only for private links
//       if (linkPrivacy !== "private") {
//         setIsCheckingAccess(false);
//         return;
//       }

//       const saved = localStorage.getItem(UNIFIED_STORAGE_KEY);
//       if (!saved) {
//         setIsCheckingAccess(false);
//         return;
//       }

//       try {
//         const parsed = JSON.parse(saved);
//         if (!parsed?.user) {
//           localStorage.removeItem(UNIFIED_STORAGE_KEY);
//           setIsCheckingAccess(false);
//           return;
//         }

//         // Check if user has access to this private link
//         const response = await axios.post(
//           `${API_BASE_URL}/api/auth/check-access`,
//           {
//             user_id: String(parsed.user.id),
//             link_id: linkId,
//           },
//         );

//         if (response.data?.data?.access === true) {
//           // Create session
//           const sessionID = handleCreateSessionID(parsed.user.id, linkId);
//           const checkSessionURL = `${API_BASE_URL}/api/auth/link/session/status/${sessionID}`;

//           let sessionInfo;
//           try {
//             const sessionRes = await axios.get(checkSessionURL);
//             if (sessionRes.data?.success && sessionRes.data?.data) {
//               sessionInfo = sessionRes.data.data;
//             } else {
//               // Create new session
//               const createSessionURL = `${API_BASE_URL}/api/auth/link/session/create`;
//               await axios.post(createSessionURL, {
//                 session_id: sessionID,
//                 link_id: linkId,
//                 user_id: parsed.user.id,
//                 expires_at: getExpiryTime(),
//               });

//               const refetchRes = await axios.get(checkSessionURL);
//               sessionInfo = refetchRes.data?.data;
//             }
//           } catch (err) {
//             console.error("Session creation error:", err);
//           }

//           // Log activity
//           await logUserActivity({
//             user_id: parsed.user.id,
//             store_id: Number(mfr_id),
//             linkid: linkId,
//             action_type: "LOGIN",
//             tag_no: null,
//           });

//           // Trigger login success
//           if (onLoginSuccess) {
//             onLoginSuccess(parsed.user, sessionInfo);
//           }
//         } else {
//           setIsCheckingAccess(false);
//           // Don't call onLoginSuccess - just show the form
//         }
//       } catch (err) {
//         console.error("Access check failed:", err);
//         setIsCheckingAccess(false);
//       }
//     };

//     checkAccessAndAutoLogin();
//   }, [linkPrivacy, linkId, onLoginSuccess, mfr_id]);

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       if (!showOTPSection) {
//         if (mobile.length === 10) handleGetOtp();
//       } else if (!showNameSection) {
//         if (isVerifyEnabled) handleVerifyOtp();
//       } else {
//         if (isVerifyEnabled) handleRequestAccess();
//       }
//     }
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value.replace(/\D/g, "");
//     if (value.length <= 10) setMobile(value);
//   };

//   const isVerifyEnabled = showNameSection
//     ? name.trim() !== ""
//     : otp.every((digit) => digit.trim() !== "");

//   const handleOtpChange = (index, value) => {
//     if (!/^\d*$/.test(value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = value.slice(-1);
//     setOtp(newOtp);

//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`).focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace" && e.repeat) {
//       e.preventDefault();
//       setOtp(["", "", "", "", "", ""]);
//       document.getElementById("otp-0").focus();
//     } else if (e.key === "Backspace" && !otp[index]) {
//       if (index > 0) document.getElementById(`otp-${index - 1}`).focus();
//     }
//   };

//   const handleGetOtp = async () => {
//     if (mobile.length !== 10) {
//       setOpenSnackbar(true);
//       setSnackbarMessage("Please enter a valid 10-digit mobile number");
//       setSnackbarSeverity("error");
//       return;
//     }

//     try {
//       const URL = `${API_BASE_URL}/api/auth/customerlogin`;
//       const res = await axios.post(URL, { mobile });

//       setShowOTPSection(true);
//       const msg = res.data?.data?.message || "OTP sent successfully";
//       setSnackbarMessage(msg);
//       setSnackbarSeverity("success");
//       setOpenSnackbar(true);
//     } catch (error) {
//       setOpenSnackbar(true);
//       setSnackbarMessage(extractErrorMessage(error));
//       setSnackbarSeverity("error");
//     }
//   };

//   const handleCreateSessionID = (userID, linkID) => {
//     try {
//       const salt = "XyZ123";
//       const rawString = `${userID}:${linkID}:${salt}`;
//       let encoded = btoa(rawString)
//         .replace(/\+/g, "-")
//         .replace(/\//g, "_")
//         .replace(/=+$/, "");

//       let numericString = "";
//       for (let char of encoded) {
//         if (/[0-9]/.test(char)) numericString += char;
//         else numericString += (char.charCodeAt(0) % 10).toString();
//       }

//       return numericString.slice(0, 32);
//     } catch (error) {
//       console.error("Error creating session ID:", error);
//       return null;
//     }
//   };

//   const logUserActivity = async ({
//     user_id,
//     store_id,
//     linkid,
//     action_type,
//     tag_no,
//   }) => {
//     try {
//       await axios.post(`${API_BASE_URL}/api/auth/activity/log`, {
//         user_id,
//         store_id,
//         linkid,
//         action_type,
//         tag_no,
//       });
//     } catch (err) {
//       console.error("Activity log failed:", err.message);
//     }
//   };

//   const getExpiryTime = () => {
//     const now = new Date();
//     const expires = new Date(now.getTime() + 60 * 60 * 1000);
//     const pad = (n) => (n < 10 ? "0" + n : n);
//     return `${expires.getFullYear()}-${pad(expires.getMonth() + 1)}-${pad(
//       expires.getDate(),
//     )} ${pad(expires.getHours())}:${pad(expires.getMinutes())}:${pad(
//       expires.getSeconds(),
//     )}`;
//   };

//   const handleVerifyOtp = async () => {
//     if (!isVerifyEnabled) return;

//     const otpValue = otp.join("");

//     try {
//       const validateURL = `${API_BASE_URL}/api/auth/validate-link-otp`;

//       let validateRes;
//       try {
//         validateRes = await axios.post(validateURL, {
//           mobile,
//           otp: otpValue,
//           store_id,
//           mfr_id,
//           link_id: linkId,
//           link_name: linkName,
//         });
//       } catch (otpError) {
//         // 404 = mobile not registered in any store (server now returns 404 for this case)
//         // 401 = wrong OTP — both surface the server's own message
//         if (otpError?.response?.status === 404) {
//           setShowNonExistingUserError(true);
//           setShowOTPSection(true);
//           setSnackbarMessage(
//             otpError.response?.data?.data?.message ||
//               "Mobile number does not belong to any store. Please contact the Digital Marketer.",
//           );
//           setSnackbarSeverity("warning");
//           setOpenSnackbar(true);
//           return;
//         }
//         throw otpError; // re-throw 401, 500, network errors — caught by outer catch
//       }

//       if (validateRes.data.statusCode !== 200) {
//         throw new Error("Invalid OTP");
//       }

//       let loginUserInfo = validateRes.data?.data?.user;
//       let user_id = loginUserInfo?.id;

//       if (!loginUserInfo) {
//         setShowNonExistingUserError(true);
//         setShowNameSection(true);
//         setSnackbarMessage("User not found. Please request access.");
//         setSnackbarSeverity("warning");
//         setOpenSnackbar(true);
//         return;
//       }

//       setUserInfo(loginUserInfo);

//       // Check access for BOTH public and private links
//       let accessStatus = false;
//       try {
//         const checkAccessURL = `${API_BASE_URL}/api/auth/check-access`;
//         const checkRes = await axios.post(checkAccessURL, {
//           user_id: String(user_id),
//           link_id: linkId,
//         });
//         accessStatus = checkRes.data?.data?.access;
//       } catch (accessError) {
//         // Network/server error on access check — treat as no access yet
//         console.error("Access check error:", extractErrorMessage(accessError));
//         accessStatus = false;
//       }

//       if (!accessStatus) {
//         setShowNameSection(true);
//         setSnackbarMessage("Access not found. Please request access.");
//         setSnackbarSeverity("warning");
//         setOpenSnackbar(true);
//         return;
//       }

//       // ✅ Access exists → Continue login

//       // 🟢 PUBLIC LINK: No session needed
//       if (linkPrivacy === "public") {
//         localStorage.setItem(
//           UNIFIED_STORAGE_KEY,
//           JSON.stringify({
//             user: loginUserInfo,
//             mobile: mobile,
//           }),
//         );

//         if (onLoginSuccess) onLoginSuccess(loginUserInfo, null);

//         setSnackbarMessage(`Welcome ${loginUserInfo.name || "Guest"}`);
//         setSnackbarSeverity("success");
//         setOpenSnackbar(true);

//         await logUserActivity({
//           user_id,
//           store_id: Number(mfr_id),
//           linkid: linkId,
//           action_type: "LOGIN",
//           tag_no: null,
//         });

//         return;
//       }

//       // 🔒 PRIVATE LINK: Create session
//       const sessionID = handleCreateSessionID(user_id, linkId);
//       const checkSessionURL = `${API_BASE_URL}/api/auth/link/session/status/${sessionID}`;

//       let checkSessionRes = await axios.get(checkSessionURL);
//       let sessionInfo;

//       if (checkSessionRes.data?.success && checkSessionRes.data?.data) {
//         sessionInfo = checkSessionRes.data.data;
//       } else {
//         const createSessionURL = `${API_BASE_URL}/api/auth/link/session/create`;
//         const createSessionPayload = {
//           session_id: sessionID,
//           link_id: linkId,
//           user_id,
//           expires_at: getExpiryTime(),
//         };

//         await axios.post(createSessionURL, createSessionPayload);

//         const refetchRes = await axios.get(checkSessionURL);
//         if (refetchRes.data?.success && refetchRes.data?.data) {
//           sessionInfo = refetchRes.data.data;
//         } else {
//           throw new Error("Failed to fetch session info after creation");
//         }
//       }

//       localStorage.setItem(
//         UNIFIED_STORAGE_KEY,
//         JSON.stringify({
//           user: loginUserInfo,
//           session: sessionInfo,
//           mobile: mobile,
//         }),
//       );

//       if (onLoginSuccess) onLoginSuccess(loginUserInfo, sessionInfo);

//       setSnackbarMessage("Access granted");
//       setSnackbarSeverity("success");
//       setOpenSnackbar(true);

//       await logUserActivity({
//         user_id,
//         store_id: Number(mfr_id),
//         linkid: linkId,
//         action_type: "LOGIN",
//         tag_no: null,
//       });
//     } catch (error) {
//       console.error("Verification error:", error);
//       setSnackbarMessage(
//         extractErrorMessage(error, "OTP verification failed. Try again."),
//       );
//       setSnackbarSeverity("error");
//       setOpenSnackbar(true);
//     }
//   };

//   const handleRequestAccess = async () => {
//     if (isRequesting || requestSent) return;

//     // userInfo can be null when showNameSection is triggered via non-existing user path
//     if (!userInfo && !name.trim()) {
//       setSnackbarMessage("Please enter your name to request access.");
//       setSnackbarSeverity("warning");
//       setOpenSnackbar(true);
//       return;
//     }

//     setIsRequesting(true);

//     try {
//       const URL = `${API_BASE_URL}/api/auth/temp-user-auth`;
//       const payload = {
//         name: userInfo?.name || name.trim(),
//         mobile_number: mobile,
//         mfr_id,
//         link_id: linkId,
//       };

//       const res = await axios.post(URL, payload);

//       if (res.data.statusCode !== 200) {
//         throw new Error(res.data?.data?.message || "Unexpected response");
//       }

//       setRequestSent(true);

//       await logUserActivity({
//         user_id: userInfo?.id || null,
//         store_id: Number(mfr_id),
//         linkid: linkId,
//         action_type: "REQUEST_ACCESS",
//         tag_no: null,
//       });

//       setSnackbarMessage(
//         "Access request sent successfully. You'll be notified once approved.",
//       );
//       setSnackbarSeverity("success");
//       setOpenSnackbar(true);
//     } catch (error) {
//       console.error(error);
//       setSnackbarMessage(
//         extractErrorMessage(error, "Failed to send access request. Try again."),
//       );
//       setSnackbarSeverity("error");
//       setOpenSnackbar(true);
//     } finally {
//       setIsRequesting(false);
//     }
//   };

//   const handleRetry = async () => {
//     if (isRetrying) return;

//     setIsRetrying(true);
//     setRetryMessage("Checking your access status...");

//     try {
//       // Call check access API
//       const response = await axios.post(
//         `${API_BASE_URL}/api/auth/check-access`,
//         {
//           user_id: String(userInfo.id),
//           link_id: linkId,
//         },
//       );

//       const accessStatus = response.data?.data?.access;

//       if (accessStatus === true) {
//         // ✅ Access granted! Auto-login

//         setRetryMessage("Access approved! Logging you in...");

//         // Create session for private link
//         const sessionID = handleCreateSessionID(userInfo.id, linkId);
//         const checkSessionURL = `${API_BASE_URL}/api/auth/link/session/status/${sessionID}`;

//         let sessionInfo;
//         try {
//           const sessionRes = await axios.get(checkSessionURL);
//           if (sessionRes.data?.success && sessionRes.data?.data) {
//             sessionInfo = sessionRes.data.data;
//           } else {
//             // Create new session
//             const createSessionURL = `${API_BASE_URL}/api/auth/link/session/create`;
//             await axios.post(createSessionURL, {
//               session_id: sessionID,
//               link_id: linkId,
//               user_id: userInfo.id,
//               expires_at: getExpiryTime(),
//             });

//             const refetchRes = await axios.get(checkSessionURL);
//             sessionInfo = refetchRes.data?.data;
//           }
//         } catch (err) {
//           console.error("Session creation error:", err);
//         }

//         // Save to unified storage
//         localStorage.setItem(
//           UNIFIED_STORAGE_KEY,
//           JSON.stringify({
//             user: userInfo,
//             session: sessionInfo,
//             mobile: mobile,
//           }),
//         );

//         // Log activity
//         await logUserActivity({
//           user_id: userInfo.id,
//           store_id: Number(mfr_id),
//           linkid: linkId,
//           action_type: "LOGIN",
//           tag_no: null,
//         });

//         // Trigger login success
//         if (onLoginSuccess) {
//           onLoginSuccess(userInfo, sessionInfo);
//         }

//         setSnackbarMessage("Access approved! Welcome!");
//         setSnackbarSeverity("success");
//         setOpenSnackbar(true);
//       } else {
//         // ❌ Still no access
//         setRetryMessage(
//           "Your request is pending. Please be patient, your access request will be approved as soon as possible.",
//         );
//         setLastRetryTime(new Date());
//       }
//     } catch (error) {
//       console.error("Retry error:", error);
//       setRetryMessage(
//         extractErrorMessage(
//           error,
//           "Unable to check status. Please try again in a moment.",
//         ),
//       );
//       setLastRetryTime(new Date());
//     } finally {
//       setIsRetrying(false);
//     }
//   };

//   // Format last retry time
//   const formatRetryTime = (date) => {
//     if (!date) return "";

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     const hours = String(date.getHours()).padStart(2, "0");
//     const minutes = String(date.getMinutes()).padStart(2, "0");
//     const seconds = String(date.getSeconds()).padStart(2, "0");

//     return `${hours}:${minutes}:${seconds}`;
//   };

//   // Show loading while checking access (only for private links)
//   if (isCheckingAccess && linkPrivacy === "private") {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           minHeight: "100vh",
//           gap: 2,
//         }}
//       >
//         <CircularProgress />
//         <Typography variant="body2" color="text.secondary">
//           Checking your access status...
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <>
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: "#f5f5f5",
//         }}
//         onKeyDown={handleKeyDown}
//         tabIndex={0}
//       >
//         <Paper
//           elevation={4}
//           sx={{
//             p: 4,
//             width: "90%",
//             maxWidth: 400,
//             borderRadius: 3,
//             textAlign: "center",
//           }}
//         >
//           {/* Store Information */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexDirection: "column",
//               mb: 3,
//             }}
//           >
//             <Box
//               sx={{
//                 width: 125,
//                 height: 125,
//                 m: "0 auto",
//                 mb: 1,
//                 borderRadius: 100,
//                 boxShadow: storeInformation?.logo
//                   ? "0px 0px 15px rgba(19, 101, 109, 0.3)"
//                   : "none",
//                 backgroundColor: storeInformation?.logo
//                   ? "transparent"
//                   : "#e0e0e0",
//                 backgroundImage: storeInformation?.logo
//                   ? `url("${storeInformation.logo}")`
//                   : "none",
//                 backgroundSize: "contain",
//                 backgroundRepeat: "no-repeat",
//                 backgroundPosition: "center",
//                 transition: "transform 0.25s ease-out",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 "&:hover": {
//                   transform: "scale(1.05)",
//                 },
//               }}
//             >
//               {!storeInformation?.logo && (
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     color: "#999",
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                   }}
//                 >
//                   No Logo
//                 </Typography>
//               )}
//             </Box>

//             {storeInformation?.name && (
//               <Typography
//                 sx={{ fontSize: 20, fontWeight: "600", color: "#333" }}
//               >
//                 {storeInformation.name}
//               </Typography>
//             )}

//             {storeInformation?.place && (
//               <Typography sx={{ color: "#666", fontSize: "14px" }}>
//                 {storeInformation.place}
//               </Typography>
//             )}
//           </Box>

//           <Typography variant="h5" fontWeight="bold" mb={3}>
//             Login
//           </Typography>

//           {/* MOBILE INPUT */}
//           <TextField
//             label="Mobile Number"
//             variant="outlined"
//             fullWidth
//             value={mobile}
//             onChange={handleMobileChange}
//             inputProps={{ maxLength: 10 }}
//             sx={{ mb: 2 }}
//             disabled={showOTPSection}
//           />

//           {/* GET OTP */}
//           {!showOTPSection && (
//             <Button
//               fullWidth
//               variant="contained"
//               color="primary"
//               onClick={handleGetOtp}
//               disabled={mobile.length !== 10}
//             >
//               Get OTP
//             </Button>
//           )}

//           {/* OTP SECTION */}
//           {showOTPSection && (
//             <Box mt={3}>
//               {!showNameSection && (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "center",
//                     gap: 1,
//                     mb: 2,
//                   }}
//                 >
//                   {otp.map((digit, index) => (
//                     <TextField
//                       key={index}
//                       id={`otp-${index}`}
//                       value={digit}
//                       onChange={(e) => handleOtpChange(index, e.target.value)}
//                       onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                       type="tel"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       autoComplete="one-time-code"
//                       inputProps={{
//                         maxLength: 1,
//                         style: {
//                           textAlign: "center",
//                           fontSize: "16px",
//                           width: "24px",
//                           height: "24px",
//                           padding: "6px",
//                         },
//                       }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderRadius: "8px",
//                           width: "36px",
//                           height: "36px",
//                         },
//                       }}
//                     />
//                   ))}
//                 </Box>
//               )}

//               {showNonExistingUserError && (
//                 <Typography sx={{ textAlign: "center" }}>
//                   You don't belong to any store. Please contact the digital
//                   marketer{" "}
//                   <Link
//                     href={`tel:${contactDM}`}
//                     underline="none"
//                     sx={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       fontWeight: 600,
//                       ml: 0.5,
//                       color: "primary.main",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: 0.5,
//                       }}
//                     >
//                       <LocalPhoneRoundedIcon sx={{ fontSize: 18 }} />
//                       {contactDM}
//                     </Box>
//                   </Link>
//                 </Typography>
//               )}

//               {!showNonExistingUserError && (
//                 <>
//                   {/* ✅ UPDATED: Show different UI for request sent state */}
//                   {!requestSent ? (
//                     <Button
//                       fullWidth
//                       variant="contained"
//                       color={showNameSection ? "success" : "primary"}
//                       onClick={
//                         showNameSection ? handleRequestAccess : handleVerifyOtp
//                       }
//                       disabled={isRequesting}
//                     >
//                       {showNameSection
//                         ? isRequesting
//                           ? "Sending..."
//                           : "Request Access"
//                         : "Verify OTP"}
//                     </Button>
//                   ) : (
//                     // ✅ NEW: Retry section after request is sent
//                     <Box>
//                       {/* Retry Message */}
//                       {retryMessage && (
//                         <Box
//                           sx={{
//                             mb: 2,
//                             p: 2,
//                             bgcolor: "#e3f2fd",
//                             borderRadius: 2,
//                             border: "1px solid #8FCFCF",
//                           }}
//                         >
//                           <Typography
//                             sx={{
//                               fontSize: "14px",
//                               color: "#0D7377",
//                               textAlign: "center",
//                             }}
//                           >
//                             {retryMessage}
//                           </Typography>
//                         </Box>
//                       )}

//                       {/* Retry Button */}
//                       <Button
//                         fullWidth
//                         variant="contained"
//                         color="primary"
//                         onClick={handleRetry}
//                         disabled={isRetrying}
//                         sx={{
//                           bgcolor: "#42A996",
//                           "&:hover": { bgcolor: "#3b927f" },
//                           "&.Mui-disabled": {
//                             bgcolor: "#7bbdb1",
//                             color: "white",
//                           },
//                         }}
//                       >
//                         {isRetrying ? (
//                           <Box
//                             sx={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: 1,
//                             }}
//                           >
//                             <CircularProgress
//                               size={20}
//                               sx={{ color: "white" }}
//                             />
//                             <span>Checking...</span>
//                           </Box>
//                         ) : (
//                           "Retry"
//                         )}
//                       </Button>

//                       {/* Last Retry Time */}
//                       {lastRetryTime && (
//                         <Typography
//                           sx={{
//                             mt: 1.5,
//                             fontSize: 14,
//                             color: "text.secondary",
//                             textAlign: "center",
//                             fontStyle: "italic",
//                           }}
//                         >
//                           Last retried: {formatRetryTime(lastRetryTime)}
//                         </Typography>
//                       )}

//                       {/* Initial Request Sent Message */}
//                       {!retryMessage && (
//                         <Typography
//                           sx={{
//                             mt: 2,
//                             fontSize: "13px",
//                             color: "text.secondary",
//                             textAlign: "center",
//                           }}
//                         >
//                           Access request sent. You'll be notified on WhatsApp
//                           once approved. Click "Retry" to check status.
//                         </Typography>
//                       )}
//                     </Box>
//                   )}
//                 </>
//               )}
//             </Box>
//           )}
//         </Paper>
//       </Box>

//       {/* Snackbar */}
//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={6000}
//         onClose={() => setOpenSnackbar(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//         sx={{
//           "&.MuiSnackbar-root": {
//             bottom: "100px !important",
//           },
//         }}
//       >
//         <Alert
//           onClose={() => setOpenSnackbar(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default FilterLoginScreen;

import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Snackbar,
  Alert,
  CircularProgress,
  Link,
} from "@mui/material";
import axios from "axios";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

// ---------------------------------------------------------------------------
// extractErrorMessage
// Priority order:
//   1. error.response.data.data.message  — your standard API envelope
//   2. error.response.data.message       — flat envelope fallback
//   3. "Network error…"                  — no response at all (offline / CORS)
//   4. error.message                     — plain JS Error
//   5. caller-supplied fallback          — last resort
//
// NOTE: Several of your APIs return HTTP 200 with a non-200 statusCode inside
// the body (checkUserLinkAccess, customerlogin, createTempUserAuth).
// Those are NOT axios errors, so they must be handled at the call-site by
// reading res.data.data.message directly — extractErrorMessage is only for
// caught axios throws.
// ---------------------------------------------------------------------------
const extractErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again.",
) => {
  if (error?.response?.data?.data?.message)
    return error.response.data.data.message;
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.message === "Network Error")
    return "Network error. Please check your connection.";
  if (error?.message) return error.message;
  return fallback;
};

const FilterLoginScreen = ({
  onLoginSuccess,
  linkName,
  linkId,
  store_id,
  mfr_id,
  linkPrivacy,
  storeInformation,
  contactDM,
}) => {
  // ✅ UNIFIED STORAGE KEY
  const UNIFIED_STORAGE_KEY = "FILTER_LINK_LOGIN_UNIFIED";

  const [mobile, setMobile] = useState("");
  const [showOTPSection, setShowOTPSection] = useState(false);
  const [showNameSection, setShowNameSection] = useState(false);
  const [name, setName] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [userInfo, setUserInfo] = useState(null);
  const [requestSent, setRequestSent] = useState(false);
  const [showNonExistingUserError, setShowNonExistingUserError] =
    useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);
  const [isRequesting, setIsRequesting] = useState(false);

  // Retry feature states
  const [isRetrying, setIsRetrying] = useState(false);
  const [lastRetryTime, setLastRetryTime] = useState(null);
  const [retryMessage, setRetryMessage] = useState("");

  // Snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Helper to fire the snackbar in one line
  const showSnackbar = (message, severity = "error") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  // ONLY access check for private links
  useEffect(() => {
    const checkAccessAndAutoLogin = async () => {
      // Only for private links
      if (linkPrivacy !== "private") {
        setIsCheckingAccess(false);
        return;
      }

      const saved = localStorage.getItem(UNIFIED_STORAGE_KEY);
      if (!saved) {
        setIsCheckingAccess(false);
        return;
      }

      try {
        const parsed = JSON.parse(saved);
        if (!parsed?.user) {
          localStorage.removeItem(UNIFIED_STORAGE_KEY);
          setIsCheckingAccess(false);
          return;
        }

        // checkUserLinkAccess always returns HTTP 200; statusCode lives in body
        const response = await axios.post(
          `${API_BASE_URL}/api/auth/check-access`,
          {
            user_id: String(parsed.user.id),
            link_id: linkId,
          },
        );

        // Body statusCode 200 + access:true → proceed; anything else → show form
        if (
          response.data?.statusCode === 200 &&
          response.data?.data?.access === true
        ) {
          // Create session
          const sessionID = handleCreateSessionID(parsed.user.id, linkId);
          const checkSessionURL = `${API_BASE_URL}/api/auth/link/session/status/${sessionID}`;

          let sessionInfo;
          try {
            const sessionRes = await axios.get(checkSessionURL);
            if (sessionRes.data?.success && sessionRes.data?.data) {
              sessionInfo = sessionRes.data.data;
            } else {
              // Create new session
              const createSessionURL = `${API_BASE_URL}/api/auth/link/session/create`;
              await axios.post(createSessionURL, {
                session_id: sessionID,
                link_id: linkId,
                user_id: parsed.user.id,
                expires_at: getExpiryTime(),
              });

              const refetchRes = await axios.get(checkSessionURL);
              sessionInfo = refetchRes.data?.data;
            }
          } catch (err) {
            console.error("Session creation error:", err);
          }

          // Log activity
          await logUserActivity({
            user_id: parsed.user.id,
            store_id: Number(mfr_id),
            linkid: linkId,
            action_type: "LOGIN",
            tag_no: null,
          });

          // Trigger login success
          if (onLoginSuccess) {
            onLoginSuccess(parsed.user, sessionInfo);
          }
        } else {
          setIsCheckingAccess(false);
          // Don't call onLoginSuccess - just show the form
        }
      } catch (err) {
        console.error("Access check failed:", err);
        setIsCheckingAccess(false);
      }
    };

    checkAccessAndAutoLogin();
  }, [linkPrivacy, linkId, onLoginSuccess, mfr_id]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!showOTPSection) {
        if (mobile.length === 10) handleGetOtp();
      } else if (!showNameSection) {
        if (isVerifyEnabled) handleVerifyOtp();
      } else {
        if (isVerifyEnabled) handleRequestAccess();
      }
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) setMobile(value);
  };

  const isVerifyEnabled = showNameSection
    ? name.trim() !== ""
    : otp.every((digit) => digit.trim() !== "");

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && e.repeat) {
      e.preventDefault();
      setOtp(["", "", "", "", "", ""]);
      document.getElementById("otp-0").focus();
    } else if (e.key === "Backspace" && !otp[index]) {
      if (index > 0) document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  // ---------------------------------------------------------------------------
  // handleGetOtp — calls customerlogin
  //
  // customerlogin ALWAYS returns HTTP 200. Error cases live in body.statusCode:
  //   400 → "Mobile number is required."           (shouldn't reach FE, guarded)
  //   500 → "An error occurred during login…"
  //   200 → OTP sent to registered user
  //   203 → OTP sent but mobile not registered (still show OTP section; user
  //          will hit 404 on validate and see the non-existing-user UI)
  //
  // We show the server's data.message in every case so the user sees the
  // exact backend wording, not a generic string.
  // ---------------------------------------------------------------------------
  const handleGetOtp = async () => {
    if (mobile.length !== 10) {
      showSnackbar("Please enter a valid 10-digit mobile number", "error");
      return;
    }

    try {
      const URL = `${API_BASE_URL}/api/auth/customerlogin`;
      const res = await axios.post(URL, { mobile });

      const bodyStatusCode = res.data?.statusCode;
      const msg = res.data?.data?.message;

      if (bodyStatusCode === 500) {
        // Server-side error surfaced through HTTP 200 wrapper
        showSnackbar(
          msg || "An error occurred during login. Please try again later.",
          "error",
        );
        return;
      }

      // 200 (registered) or 203 (unregistered) — both cases send the OTP,
      // so we open the OTP section regardless and let validateLinkOTP handle
      // the non-existing-user path.
      setShowOTPSection(true);
      showSnackbar(msg || "OTP sent successfully", "success");
    } catch (error) {
      // Network / unexpected HTTP error (customerlogin should never throw,
      // but guard just in case)
      showSnackbar(
        extractErrorMessage(error, "Failed to send OTP. Please try again."),
        "error",
      );
    }
  };

  const handleCreateSessionID = (userID, linkID) => {
    try {
      const salt = "XyZ123";
      const rawString = `${userID}:${linkID}:${salt}`;
      let encoded = btoa(rawString)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");

      let numericString = "";
      for (let char of encoded) {
        if (/[0-9]/.test(char)) numericString += char;
        else numericString += (char.charCodeAt(0) % 10).toString();
      }

      return numericString.slice(0, 32);
    } catch (error) {
      console.error("Error creating session ID:", error);
      return null;
    }
  };

  const logUserActivity = async ({
    user_id,
    store_id,
    linkid,
    action_type,
    tag_no,
  }) => {
    try {
      await axios.post(`${API_BASE_URL}/api/auth/activity/log`, {
        user_id,
        store_id,
        linkid,
        action_type,
        tag_no,
      });
    } catch (err) {
      console.error("Activity log failed:", err.message);
    }
  };

  const getExpiryTime = () => {
    const now = new Date();
    const expires = new Date(now.getTime() + 60 * 60 * 1000);
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${expires.getFullYear()}-${pad(expires.getMonth() + 1)}-${pad(
      expires.getDate(),
    )} ${pad(expires.getHours())}:${pad(expires.getMinutes())}:${pad(
      expires.getSeconds(),
    )}`;
  };

  // ---------------------------------------------------------------------------
  // handleVerifyOtp — calls validateLinkOTP then checkUserLinkAccess
  //
  // validateLinkOTP uses REAL HTTP status codes:
  //   400 (thrown) → "Mobile number and OTP are required" /
  //                  "Store ID, MFR ID, or Link ID is missing"
  //   404 (thrown) → "Mobile number does not belong to any store"
  //   401 (thrown) → dynamic OTP failure message from validatingOtp()
  //   500 (thrown) → "An error occurred during Link OTP validation…"
  //   200          → success
  //
  // checkUserLinkAccess uses HTTP 200 always; statusCode in body:
  //   400 body → "user_id and link_id are required."
  //   404 body → "Link not found."
  //   403 body → "No user groups are allowed…" / "User is not allowed…"
  //   500 body → "An error occurred while checking access."
  //   200 body → access: true / false
  // ---------------------------------------------------------------------------
  const handleVerifyOtp = async () => {
    if (!isVerifyEnabled) return;

    // Guard: if critical link params are missing, the link URL is broken/outdated.
    // Show a meaningful message instead of letting the API return a cryptic 400.
    if (!store_id || !mfr_id || !linkId) {
      setSnackbarMessage(
        "This link appears to be incomplete or outdated. Please ask for a new link.",
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    const otpValue = otp.join("");

    try {
      const validateURL = `${API_BASE_URL}/api/auth/validate-link-otp`;

      let validateRes;
      try {
        validateRes = await axios.post(validateURL, {
          mobile,
          otp: otpValue,
          store_id,
          mfr_id,
          link_id: linkId,
          link_name: linkName,
        });
      } catch (otpError) {
        const status = otpError?.response?.status;
        // All error shapes from validateLinkOTP follow { data: { message } }
        // extractErrorMessage picks that up from error.response.data.data.message
        const serverMsg = extractErrorMessage(otpError);

        if (status === 404) {
          // Mobile not registered in any store
          setShowNonExistingUserError(true);
          setShowOTPSection(true);
          showSnackbar(serverMsg, "warning");
          return;
        }

        if (status === 401) {
          // Wrong / expired OTP — show the exact message validatingOtp() returned
          showSnackbar(serverMsg, "error");
          return;
        }

        if (status === 400) {
          // Missing fields — shouldn't normally reach here, but surface it clearly
          showSnackbar(serverMsg, "error");
          return;
        }

        // 500 or network — surface server message or generic network message
        showSnackbar(
          serverMsg || "OTP verification failed. Please try again.",
          "error",
        );
        return;
      }

      // validateLinkOTP returned HTTP 200 — check body statusCode just in case
      if (validateRes.data?.statusCode !== 200) {
        showSnackbar(
          validateRes.data?.data?.message ||
            "OTP verification failed. Try again.",
          "error",
        );
        return;
      }

      let loginUserInfo = validateRes.data?.data?.user;
      let user_id = loginUserInfo?.id;

      if (!loginUserInfo) {
        setShowNonExistingUserError(true);
        setShowNameSection(true);
        showSnackbar("User not found. Please request access.", "warning");
        return;
      }

      setUserInfo(loginUserInfo);

      // -----------------------------------------------------------------------
      // checkUserLinkAccess — always HTTP 200, errors are in body.statusCode
      // -----------------------------------------------------------------------
      let accessStatus = false;
      try {
        const checkAccessURL = `${API_BASE_URL}/api/auth/check-access`;
        const checkRes = await axios.post(checkAccessURL, {
          user_id: String(user_id),
          link_id: linkId,
        });

        const accessBodyCode = checkRes.data?.statusCode;
        const accessMsg = checkRes.data?.data?.message;

        if (accessBodyCode === 200) {
          accessStatus = checkRes.data?.data?.access === true;
        } else if (accessBodyCode === 403) {
          // User exists but is not in any allowed group
          accessStatus = false;
          // Fall through to showNameSection — user will request access
        } else if (accessBodyCode === 404) {
          // Link itself not found — surface the server message
          showSnackbar(
            accessMsg || "The requested link was not found.",
            "error",
          );
          return;
        } else if (accessBodyCode === 400) {
          showSnackbar(
            accessMsg || "Invalid request. Please try again.",
            "error",
          );
          return;
        } else if (accessBodyCode === 500) {
          showSnackbar(
            accessMsg ||
              "An error occurred while checking access. Please try again.",
            "error",
          );
          return;
        }
      } catch (accessError) {
        // Network or unexpected HTTP throw from check-access
        console.error("Access check error:", extractErrorMessage(accessError));
        accessStatus = false;
      }

      if (!accessStatus) {
        setShowNameSection(true);
        showSnackbar(
          "You don't have access to this link. Please request access.",
          "warning",
        );
        return;
      }

      // ✅ Access exists → Continue login

      // 🟢 PUBLIC LINK: No session needed
      if (linkPrivacy === "public") {
        localStorage.setItem(
          UNIFIED_STORAGE_KEY,
          JSON.stringify({
            user: loginUserInfo,
            mobile: mobile,
          }),
        );

        if (onLoginSuccess) onLoginSuccess(loginUserInfo, null);

        showSnackbar(`Welcome ${loginUserInfo.name || "Guest"}`, "success");

        await logUserActivity({
          user_id,
          store_id: Number(mfr_id),
          linkid: linkId,
          action_type: "LOGIN",
          tag_no: null,
        });

        return;
      }

      // 🔒 PRIVATE LINK: Create session
      const sessionID = handleCreateSessionID(user_id, linkId);
      const checkSessionURL = `${API_BASE_URL}/api/auth/link/session/status/${sessionID}`;

      let checkSessionRes = await axios.get(checkSessionURL);
      let sessionInfo;

      if (checkSessionRes.data?.success && checkSessionRes.data?.data) {
        sessionInfo = checkSessionRes.data.data;
      } else {
        const createSessionURL = `${API_BASE_URL}/api/auth/link/session/create`;
        const createSessionPayload = {
          session_id: sessionID,
          link_id: linkId,
          user_id,
          expires_at: getExpiryTime(),
        };

        await axios.post(createSessionURL, createSessionPayload);

        const refetchRes = await axios.get(checkSessionURL);
        if (refetchRes.data?.success && refetchRes.data?.data) {
          sessionInfo = refetchRes.data.data;
        } else {
          throw new Error("Failed to fetch session info after creation");
        }
      }

      localStorage.setItem(
        UNIFIED_STORAGE_KEY,
        JSON.stringify({
          user: loginUserInfo,
          session: sessionInfo,
          mobile: mobile,
        }),
      );

      if (onLoginSuccess) onLoginSuccess(loginUserInfo, sessionInfo);

      showSnackbar("Access granted", "success");

      await logUserActivity({
        user_id,
        store_id: Number(mfr_id),
        linkid: linkId,
        action_type: "LOGIN",
        tag_no: null,
      });
    } catch (error) {
      console.error("Verification error:", error);
      showSnackbar(
        extractErrorMessage(error, "OTP verification failed. Try again."),
        "error",
      );
    }
  };

  // ---------------------------------------------------------------------------
  // handleRequestAccess — calls createTempUserAuth
  //
  // createTempUserAuth always returns HTTP 200; errors in body.statusCode:
  //   400 body → "Name, mobile_number, and mfr_id are required."
  //   404 body → "Invalid link_id. Link not found."
  //   500 body → "An error occurred while creating the record…"
  //   200 body → "Record inserted/updated successfully."
  // ---------------------------------------------------------------------------
  const handleRequestAccess = async () => {
    if (isRequesting || requestSent) return;

    if (!userInfo && !name.trim()) {
      showSnackbar("Please enter your name to request access.", "warning");
      return;
    }

    setIsRequesting(true);

    try {
      const URL = `${API_BASE_URL}/api/auth/temp-user-auth`;
      const payload = {
        name: userInfo?.name || name.trim(),
        mobile_number: mobile,
        mfr_id,
        link_id: linkId,
      };

      const res = await axios.post(URL, payload);

      const bodyStatusCode = res.data?.statusCode;
      const serverMsg = res.data?.data?.message;

      // Surface any non-200 body status code with the server's own message
      if (bodyStatusCode !== 200) {
        showSnackbar(
          serverMsg ||
            (bodyStatusCode === 404
              ? "The link could not be found. Please contact support."
              : bodyStatusCode === 400
                ? "Required information is missing. Please try again."
                : "Failed to send access request. Please try again."),
          "error",
        );
        return;
      }

      setRequestSent(true);

      await logUserActivity({
        user_id: userInfo?.id || null,
        store_id: Number(mfr_id),
        linkid: linkId,
        action_type: "REQUEST_ACCESS",
        tag_no: null,
      });

      showSnackbar(
        "Access request sent successfully. You'll be notified once approved.",
        "success",
      );
    } catch (error) {
      // Network or unexpected HTTP throw (createTempUserAuth shouldn't throw,
      // but guard just in case)
      console.error(error);
      showSnackbar(
        extractErrorMessage(error, "Failed to send access request. Try again."),
        "error",
      );
    } finally {
      setIsRequesting(false);
    }
  };

  // ---------------------------------------------------------------------------
  // handleRetry — calls checkUserLinkAccess
  //
  // Same HTTP-200-always shape as described above for checkUserLinkAccess.
  // ---------------------------------------------------------------------------
  const handleRetry = async () => {
    if (isRetrying) return;

    setIsRetrying(true);
    setRetryMessage("Checking your access status...");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/check-access`,
        {
          user_id: String(userInfo.id),
          link_id: linkId,
        },
      );

      const bodyStatusCode = response.data?.statusCode;
      const serverMsg = response.data?.data?.message;
      const accessStatus = response.data?.data?.access;

      // Surface non-200 body errors (404 link not found, 400 bad input, 500 server)
      if (bodyStatusCode !== 200) {
        setRetryMessage(
          serverMsg ||
            (bodyStatusCode === 404
              ? "Link not found. Please contact support."
              : bodyStatusCode === 500
                ? "An error occurred while checking access. Please try again."
                : "Unable to check access status. Please try again."),
        );
        setLastRetryTime(new Date());
        return;
      }

      if (accessStatus === true) {
        // ✅ Access granted! Auto-login
        setRetryMessage("Access approved! Logging you in...");

        const sessionID = handleCreateSessionID(userInfo.id, linkId);
        const checkSessionURL = `${API_BASE_URL}/api/auth/link/session/status/${sessionID}`;

        let sessionInfo;
        try {
          const sessionRes = await axios.get(checkSessionURL);
          if (sessionRes.data?.success && sessionRes.data?.data) {
            sessionInfo = sessionRes.data.data;
          } else {
            const createSessionURL = `${API_BASE_URL}/api/auth/link/session/create`;
            await axios.post(createSessionURL, {
              session_id: sessionID,
              link_id: linkId,
              user_id: userInfo.id,
              expires_at: getExpiryTime(),
            });

            const refetchRes = await axios.get(checkSessionURL);
            sessionInfo = refetchRes.data?.data;
          }
        } catch (err) {
          console.error("Session creation error:", err);
        }

        localStorage.setItem(
          UNIFIED_STORAGE_KEY,
          JSON.stringify({
            user: userInfo,
            session: sessionInfo,
            mobile: mobile,
          }),
        );

        await logUserActivity({
          user_id: userInfo.id,
          store_id: Number(mfr_id),
          linkid: linkId,
          action_type: "LOGIN",
          tag_no: null,
        });

        if (onLoginSuccess) {
          onLoginSuccess(userInfo, sessionInfo);
        }

        showSnackbar("Access approved! Welcome!", "success");
      } else {
        // ❌ Still no access — body said 200 but access: false (403 scenario)
        setRetryMessage(
          serverMsg ||
            "Your request is pending. Please be patient, your access request will be approved as soon as possible.",
        );
        setLastRetryTime(new Date());
      }
    } catch (error) {
      // Network or unexpected HTTP throw
      console.error("Retry error:", error);
      setRetryMessage(
        extractErrorMessage(
          error,
          "Unable to check status. Please try again in a moment.",
        ),
      );
      setLastRetryTime(new Date());
    } finally {
      setIsRetrying(false);
    }
  };

  // Format last retry time
  const formatRetryTime = (date) => {
    if (!date) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  // Show loading while checking access (only for private links)
  if (isCheckingAccess && linkPrivacy === "private") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Checking your access status...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
        }}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <Paper
          elevation={4}
          sx={{
            p: 4,
            width: "90%",
            maxWidth: 400,
            borderRadius: 3,
            textAlign: "center",
          }}
        >
          {/* Store Information */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              mb: 3,
            }}
          >
            <Box
              sx={{
                width: 125,
                height: 125,
                m: "0 auto",
                mb: 1,
                borderRadius: 100,
                boxShadow: storeInformation?.logo
                  ? "0px 0px 15px rgba(19, 101, 109, 0.3)"
                  : "none",
                backgroundColor: storeInformation?.logo
                  ? "transparent"
                  : "#e0e0e0",
                backgroundImage: storeInformation?.logo
                  ? `url("${storeInformation.logo}")`
                  : "none",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                transition: "transform 0.25s ease-out",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              {!storeInformation?.logo && (
                <Typography
                  variant="h6"
                  sx={{
                    color: "#999",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  No Logo
                </Typography>
              )}
            </Box>

            {storeInformation?.name && (
              <Typography
                sx={{ fontSize: 20, fontWeight: "600", color: "#333" }}
              >
                {storeInformation.name}
              </Typography>
            )}

            {storeInformation?.place && (
              <Typography sx={{ color: "#666", fontSize: "14px" }}>
                {storeInformation.place}
              </Typography>
            )}
          </Box>

          <Typography variant="h5" fontWeight="bold" mb={3}>
            Login
          </Typography>

          {/* MOBILE INPUT */}
          <TextField
            label="Mobile Number"
            variant="outlined"
            fullWidth
            value={mobile}
            onChange={handleMobileChange}
            inputProps={{ maxLength: 10 }}
            sx={{ mb: 2 }}
            disabled={showOTPSection}
          />

          {/* GET OTP */}
          {!showOTPSection && (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleGetOtp}
              disabled={mobile.length !== 10}
            >
              Get OTP
            </Button>
          )}

          {/* OTP SECTION */}
          {showOTPSection && (
            <Box mt={3}>
              {!showNameSection && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  {otp.map((digit, index) => (
                    <TextField
                      key={index}
                      id={`otp-${index}`}
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="one-time-code"
                      inputProps={{
                        maxLength: 1,
                        style: {
                          textAlign: "center",
                          fontSize: "16px",
                          width: "24px",
                          height: "24px",
                          padding: "6px",
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          width: "36px",
                          height: "36px",
                        },
                      }}
                    />
                  ))}
                </Box>
              )}

              {showNonExistingUserError && (
                <Typography sx={{ textAlign: "center" }}>
                  You don't belong to any store. Please contact the digital
                  marketer{" "}
                  <Link
                    href={`tel:${contactDM}`}
                    underline="none"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      fontWeight: 600,
                      ml: 0.5,
                      color: "primary.main",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 0.5,
                      }}
                    >
                      <LocalPhoneRoundedIcon sx={{ fontSize: 18 }} />
                      {contactDM}
                    </Box>
                  </Link>
                </Typography>
              )}

              {!showNonExistingUserError && (
                <>
                  {/* ✅ UPDATED: Show different UI for request sent state */}
                  {!requestSent ? (
                    <Button
                      fullWidth
                      variant="contained"
                      color={showNameSection ? "success" : "primary"}
                      onClick={
                        showNameSection ? handleRequestAccess : handleVerifyOtp
                      }
                      disabled={isRequesting}
                    >
                      {showNameSection
                        ? isRequesting
                          ? "Sending..."
                          : "Request Access"
                        : "Verify OTP"}
                    </Button>
                  ) : (
                    // ✅ NEW: Retry section after request is sent
                    <Box>
                      {/* Retry Message */}
                      {retryMessage && (
                        <Box
                          sx={{
                            mb: 2,
                            p: 2,
                            bgcolor: "#e3f2fd",
                            borderRadius: 2,
                            border: "1px solid #8FCFCF",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "#0D7377",
                              textAlign: "center",
                            }}
                          >
                            {retryMessage}
                          </Typography>
                        </Box>
                      )}

                      {/* Retry Button */}
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleRetry}
                        disabled={isRetrying}
                        sx={{
                          bgcolor: "#42A996",
                          "&:hover": { bgcolor: "#3b927f" },
                          "&.Mui-disabled": {
                            bgcolor: "#7bbdb1",
                            color: "white",
                          },
                        }}
                      >
                        {isRetrying ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <CircularProgress
                              size={20}
                              sx={{ color: "white" }}
                            />
                            <span>Checking...</span>
                          </Box>
                        ) : (
                          "Retry"
                        )}
                      </Button>

                      {/* Last Retry Time */}
                      {lastRetryTime && (
                        <Typography
                          sx={{
                            mt: 1.5,
                            fontSize: 14,
                            color: "text.secondary",
                            textAlign: "center",
                            fontStyle: "italic",
                          }}
                        >
                          Last retried: {formatRetryTime(lastRetryTime)}
                        </Typography>
                      )}

                      {/* Initial Request Sent Message */}
                      {!retryMessage && (
                        <Typography
                          sx={{
                            mt: 2,
                            fontSize: "13px",
                            color: "text.secondary",
                            textAlign: "center",
                          }}
                        >
                          Access request sent. You'll be notified on WhatsApp
                          once approved. Click "Retry" to check status.
                        </Typography>
                      )}
                    </Box>
                  )}
                </>
              )}
            </Box>
          )}
        </Paper>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{
          "&.MuiSnackbar-root": {
            bottom: "100px !important",
          },
        }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FilterLoginScreen;
